module.exports = __webpack_public_path__ + "static/media/grid-image-2.be25fc31.png";